import { render, staticRenderFns } from "./ProjectAnalytics.vue?vue&type=template&id=6130bb53&"
import script from "./ProjectAnalytics.vue?vue&type=script&lang=js&"
export * from "./ProjectAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports